import React from 'react';
import { 
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody
} from '@chakra-ui/react';
import './LoadingModal.css'; // Import your CSS styles

const LoadingModal = ({ isOpen, onClose }) => {
  return (
    <Modal isCentered isOpen={isOpen} onClose={onClose} size="sm">
      <ModalOverlay bg="blackAlpha.400" p={0}/>
      <ModalContent
      marginLeft={{xl:"250px", md:"0px"}}
      width={{sm:"90%"}}
      >
        <ModalBody>
        <div class="loading-container">
            <div class="loading-text">
                <span>G</span>
                <span>r</span>
                <span>i</span>
                <span>d</span>
                <span>&nbsp;</span>
                <span>A</span>
                <span>I</span>
                <span>&nbsp;</span>
                <span>i</span>
                <span>s</span>
                <span>&nbsp;</span>
                <span>t</span>
                <span>h</span>
                <span>i</span>
                <span>n</span>
                <span>k</span>
                <span>i</span>
                <span>n</span>
                <span>g</span>
                <span>&nbsp;</span>
                <span>.</span>
                <span>.</span>
                <span>.</span>
            </div>
            </div>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default LoadingModal;

